import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import * as cn from 'classnames'
import { Link } from '@amzn/dvui/dist/Link'
import { TextLocalizer } from '../localizer/localizer'
import { StringId } from '../localizer/stringId'
import { tryCatch } from '../../utils/tryCatch'
import * as utilityClasses from '../utilityClasses.module.scss'
import * as st from './btfMorePurchaseOptions.module.scss'
import { ModalTrigger } from '@shared/utils/modalTrigger/ModalTrigger'
import { MwtwModal } from '../acquisition/moreWaysToWatchModal'

//TODO: Move to selector once btf using them
export const shouldShowMoreWaysToWatch = (
  moreWaysToWatch?: WpsRuntime.atv.wps.AcquisitionActionTreeModelProps
) => {
  if (!moreWaysToWatch) {
    return false
  }

  return (
    (
      (moreWaysToWatch as
        | WpsRuntime.atv.wps.AcquisitionActionTreeRightProps
        | WpsRuntime.atv.wps.AcquisitionActionTreeLeftProps).children || []
    ).length > 0
  )
}

export interface IBTFMorePurchaseOptionProps {
  sequenceNumber?: number
  moreWaysToWatch?: WpsRuntime.atv.wps.AcquisitionActionTreeModelProps
  titleId?: string
  toggleGiftCardModal?: () => void
  componentClassName?: string
  linkClassName?: string
}

export const BtfMorePurchaseOptions = tryCatch(
  ({
    moreWaysToWatch,
    sequenceNumber,
    titleId,
    toggleGiftCardModal,
    componentClassName,
    linkClassName
  }: IBTFMorePurchaseOptionProps) => {
    if (!shouldShowMoreWaysToWatch(moreWaysToWatch) || !titleId) {
      return null
    }

    return (
      <div className={cn(utilityClasses.stretchHeight, componentClassName)}>
        <ModalTrigger
          size='m'
          modalId='dvui-close-overlay-btf-mwtw'
          modalContent={({ closeModal }) => (
            <MwtwModal
              closeModal={closeModal}
              moreWaysToWatch={moreWaysToWatch}
              sequenceNumber={sequenceNumber}
              toggleGiftCardModal={toggleGiftCardModal}
            />
          )}
          toggle={({ openModalClickHandler }) => (
            <Link
              className={cn(st.trigger, linkClassName)}
              data-ux-click
              onClick={openModalClickHandler}>
              <TextLocalizer stringID={StringId.DV_MWTW_TITLE} />
            </Link>
          )}
        />
      </div>
    )
  }
)
